import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron",
  "use": "icon-chevron-usage",
  "viewBox": "0 0 7 4",
  "content": "<symbol viewBox=\"0 0 7 4\" id=\"icon-chevron\">\n    <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.752.744L3.753 3.886a.5.5 0 0 1-.636 0L.12.744A.374.374 0 0 1 .127.19.462.462 0 0 1 .73.183l2.704 2.832L6.139.183a.462.462 0 0 1 .604.007c.166.152.17.398.009.554z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/chevron.svg
// module id = 103
// module chunks = 2